import { Outlet, useLocation } from "react-router-dom";

import { ReactComponent as ScraperAPILogo } from "assets/icons/scraperapi-logo.svg";
import { ReactComponent as ScraperAPIIllustration } from "assets/images/scraperapi-illustration.svg";
import WebinarPromo, { WEBINAR_START_AT } from "components/WebinarPromo";
import { isPromoPathname } from "components/WebinarPromo/promoVisibility";
import { useWebinarActive } from "components/WebinarPromo/useCountdown";

function DefaultRightPanel() {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full bg-brandLightest dark:bg-primary-50">
      <ScraperAPIIllustration className="w-3/5 my-16 max-w-[640px]" />
      <div className="flex flex-col text-2xl lg:text-3xl text-center mb-16 mx-10">
        <span>Web Scraping is complex.</span>
        <span>We make it simple.</span>
      </div>
    </div>
  );
}

export default function BeforeLoginLayout() {
  const location = useLocation();

  const isPromoRoute = isPromoPathname(location.pathname);
  const isWebinarActive = useWebinarActive(WEBINAR_START_AT);
  const showPromo = isPromoRoute && isWebinarActive;

  return (
    <div className="z-10 flex flex-col md:flex-row w-full min-h-full">
      <div className="flex-1">
        <div className="relative flex items-center justify-center w-full h-full px-4 md:px-8">
          <div className="absolute top-4 left-4 w-44">
            <ScraperAPILogo />
          </div>
          <div className="w-full max-w-[500px] mt-24 mb-20 md:my-20">
            <Outlet />
          </div>
        </div>
      </div>
      <div className="relative flex-1">
        {showPromo ? (
          <div className="w-full h-full bg-brandDarkest">
            <WebinarPromo />
          </div>
        ) : (
          <DefaultRightPanel />
        )}
      </div>
    </div>
  );
}
